<template>
  <section class="welcome-section">
    <v-landing-container>
      <div class="welcome">
        <div class="welcome__content">
          <div class="welcome__desc" v-html="$t('v.home.description')"></div>
          <div class="welcome__button">
            <a
              :href="yandexLink"
              class="button button--yandex"
              :disabled="loading"
            >
              {{ $t('v.home.buttonYandex') }}
            </a>
          </div>
        </div>
      </div>
    </v-landing-container>
  </section>
</template>

<script>
import * as type from '@/store/types'
import VLandingContainer from '@/components/Landing/VLandingContainer.vue'

export default {
  name: 'HomeWelcome',
  components: {
    VLandingContainer
  },
  data() {
    return {
      yandexLink: `https://oauth.yandex.ru/authorize?response_type=
code&client_id=3a7d6ddb33dc4ae4be1fad72401d2149&redirect_uri=${document.location.origin}/`
    }
  },

  computed: {
    loading() {
      return this.$store.state[type.SESSION].loading
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/scss/vars";
@import "../../../assets/style/scss/extends";

.welcome-section {
  background-image: url(/bg_composition.jpg);
  background-size: cover;
  background-position: center center;

}

@media (-webkit-min-device-pixel-ratio: 1.5),
(min-resolution: 144dpi) {
  .welcome-section {
    background-image: url(/bg_composition@2x.jpg);
  }
}

.welcome {
  padding-top: 208px;
  padding-bottom: 369px;
  display: flex;
  position: relative;
}

.welcome__content {
  font-family: $font-gilroy;
  width: 63%;
}

.welcome__desc {
  font-size: 50px;
  line-height: 1.18;
  color: $white;
  font-weight: map-get($font-weight, "extra-bold");
  margin-bottom: 36px;
}

.welcome__sub {
  font-weight: map-get($font-weight, "light");
}
</style>
